<template>
  <div class="contact-information">
    <div class="contact-content">
        <div class="form-row">
          <div class="form-field form-field-email">
            <!-- <label for="email">Email</label> -->
            <input type="email" id="email" placeholder="Email" name="email" v-model="customer.email"  v-on:blur="validateEmail">
            <span v-for="error in errors.email" :key="error">* {{error}}</span>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field form-field-phone">
           <!--  <label for="phone">Phone number <span class="label-extra-info">Incl Country Code</span></label> -->
            <input type="tel" id="phone" placeholder="Phone Number Incl Country Code" name="phone" v-model="customer.phoneNumber" v-on:blur="validatePhone">
            <span v-for="error in errors.phone" :key="error">* {{error}}</span>
          </div> 
        </div> 
    </div>
  </div>
</template>

<script>
export default {
    name: "contactInformation",
    data() {
         return {
          customer: {},
          errors: {
            email:[],
            phone:[]
          },
      }
    },
    mounted() {
      this.customer = this.checkoutCustomerModel;
    },
    methods: {
      validateEmail() {
        var email = this.customer.email;
        if(email !== null){
          /*eslint-disable */
          var result = email.toString().match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
          if(result === null)
            this.addError("email", "Not a valid email address"); 
          else{
            this.updateStore("customer", this.customer); 
            this.RemoveError("email");
          }
        }
      },
       validatePhone() {
         var phone = this.customer.phoneNumber;
         if(phone !== null){
           /*eslint-disable */
            var result = phone.toString().match(/^[\+0]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/);
            if(result === null)
              this.addError("phone", "Not a valid phone number"); 
            else{
              this.updateStore("customer", this.customer); 
              this.RemoveError("phone");
            }
         }
      },
      updateStore(property, value) {
        this.$store.dispatch("CHECKOUT/UPDATE_CHECKOUT_MODEL_FIELD", { property: property, value: value });
      },
      addError(property, error) {
        var listOfErrors = this.errors[property];
        if(listOfErrors.indexOf(error) === -1)
        {
            listOfErrors.push(error);
        }
      },
      RemoveError(property) {
        this.errors[property] = [];
      }
    },
    computed: {
        checkoutCustomerModel() {
          return this.$store.getters["CHECKOUT/GET_CHECKOUT_MODEL"].customer;
        }
    },
}
</script>

<style lang="postcss" scoped>

input {
  background-color: white;
  padding: 10px;
  width: auto;
  -webkit-appearance: none;
  border-radius: 0;
}
label { font-size: 0.9em; }
  
.contact-information {  
    display: flex;
    width: 100%;
    order: 1;
}
.contact-content {
    width: 100%;
}

@media only screen and (max-width: 768px) {
  
  
    input {padding: 18px 6px 14px 6px;}

  .form-field-email,
  .form-field-phone {
    width: 100%;
  }

  
}

</style>